import { ArrowDropDown, ArrowDropUp } from '@material-ui/icons';
import DayJS from 'react-dayjs';
import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom'
import QuestionnaireButton from '../../../components/molecule/Questionnaire/QuestionnaireButton';


const StyledThead = styled.thead`
  position: sticky;
  top: 0;
`
const TableHeader = styled.th`
  text-align: center;
  height: 100%;
  background-color: #f2f2f2;
  font-weight: bold;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const TableWrapper = styled.div`
  overflow-y: scroll;
  overflow-x: scroll;
  width: 100%;
  max-height: 500px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);
`;

const TableRow = styled.tr`
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.1);
  border-bottom: 1px solid #ddd;
  cursor: pointer;
`;

const TableData = styled.td`
  text-align: center;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
`;

const QuestionnaireButtonStyled = styled(QuestionnaireButton)`
  margin: 10px 0 0 auto;
`

const SortableHeader = ({ children, onClick, sortOrder }) => (
    <TableHeader onClick={onClick}>
      {children}
      {sortOrder === 'asc' ? <ArrowDropUp /> : sortOrder === 'desc' ? <ArrowDropDown /> : ''}
    </TableHeader>
);

const DynamicTable = ({ data, columnKeys, columnNames, items, showQuestions = false , button }) => {
    const [sortedColumn, setSortedColumn] = React.useState(null);
    const [sortOrder, setSortOrder] = React.useState(null);
    const history = useHistory();
    const currentPageSlug = history.location.pathname;

    const handleRowClick = id => {
      const filteredItem = items?.find(item => item.id === id)
      if(id) history.push(`${currentPageSlug}${id}`, { individualCoach: filteredItem });
    };
  
    const handleSort = key => {
      if (key === sortedColumn) {
        setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
      } else {
        setSortedColumn(key);
        setSortOrder('asc');
      }
    };
  
    const sortedData = React.useMemo(() => {
      if (!sortedColumn) {
        return data;
      }
  
      return [...data].sort((a, b) => {
        if (sortOrder === 'asc') {
          return a[sortedColumn] > b[sortedColumn] ? 1 : -1;
        }
        return a[sortedColumn] < b[sortedColumn] ? 1 : -1;
      });
    }, [data, sortedColumn, sortOrder]);
    return (
      <TableWrapper>
        <Table>
          <StyledThead>
            <TableRow>
              {columnKeys?.map((key, index) => (
                <SortableHeader
                  key={key}
                  onClick={() => handleSort(key)}
                  sortOrder={sortedColumn === key ? sortOrder : null}
                >
                  {columnNames[index] || key}
                </SortableHeader>
              ))}
            </TableRow>
          </StyledThead>
          <tbody>
            {sortedData && sortedData.length > 0 && sortedData?.map((row, index) => {
              return (<TableRow key={index} onClick={() => handleRowClick(row.id)}>
                {columnKeys?.map(key => {
                 return (<TableData key={`${index}-${key}`}>
                 {['created', 'updated'].includes(key) ? (
                   <DayJS format="ddd MMM D, YYYY h:mm a">{row[key]}</DayJS>
                 ) : (
                   showQuestions && ['results.questions'].includes(key) ? <QuestionnaireButtonStyled
                   questionsAnswers={ row[key]}
                   header="Complete Request"
                   subheader="Meet Trainer Request is complete when the tasks below are complete."
                 /> : row[key]
                 )}
               </TableData>)
               
                 })}
              </TableRow>)
})}
          </tbody>
        </Table>
      </TableWrapper>
    );
};  

export default DynamicTable;